// Module
var code = `<div class="news-feed"> <news-feed patient-id="{{vm.patientId}}" feed="{{vm.feed}}"></news-feed> <drilldown-modal event-data="drilldownData" event-type="drilldownType"></drilldown-modal> </div> `;
// Exports
export default code;